import { useState } from 'react';
// import { fieldNames } from '../../components/PIForm/Steps/step3/utils'
import { stepFourFieldNames } from '../../components/creditInfoForm/steps/step4/utils'

const {
  CONFIRMATION_STATUS
} = stepFourFieldNames;


const initState = {
  [CONFIRMATION_STATUS]: false,
};

function useStepFourValues() {
  const [stepFourValues, setStepFourValues] = useState(initState);
  return { stepFourValues, setStepFourValues };
}

export default useStepFourValues;